import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SeatMapContainer } from '@seat-map/seat-map.container';

export const seatMapRootRoute = 'seat-map';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: ':itineraryId',
        component: SeatMapContainer
      },
      {
        path: ':itineraryId/:flightIdx',
        component: SeatMapContainer
      }
    ])
  ],
  exports: [RouterModule]
})
export class SeatMapRoutingModule { }
